import { Guid } from 'guid-typescript';

import { AppModules, eModuleTypes, Permissions } from '@/models/enums';
import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';
import { globalSettingsHelper } from '@/helpers/settings-helper';
import { userModulesHelper } from '@/helpers/modules-helper';

export class NavigationModule {
  public childModules: Array<NavigationModule> = [];
  public subModules: Array<NavigationModule> = [];
  public colorHex: string | null;
  public folderId: number;
  public hint: string = '';
  public icon: string;
  public isNew: boolean = false;
  public moduleType: eModuleTypes;
  public name: string = '';
  public route: string;
  public uid: string = Guid.raw();
  public unreadCount: number = 0;

  public constructor(moduleType: eModuleTypes, icon: string, route: string, colorHex: string | null, folderId: number, foldername?: string,
    isNew?: boolean) {
    this.moduleType = moduleType;
    if (this.moduleType === eModuleTypes.Folder && foldername) {
      this.hint = foldername;
      this.name = foldername;
    } else {
      this.hint = `navigation.modules.${eModuleTypes[moduleType]}.hint`;
      this.name = `navigation.modules.${eModuleTypes[moduleType]}.name`;
    }
    this.icon = icon;
    this.route = route;
    this.colorHex = colorHex;
    this.folderId = folderId;
    this.isNew = isNew || false;
  }

  public AddModule(NavigationModule) {
    this.childModules.push(NavigationModule);
  }

  public AddSubModule(NavigationModule) {
    this.subModules.push(NavigationModule);
  }
}

export class Navigations {
  public mainModules: Array<NavigationModule>;
  public additionalModules: Array<NavigationModule>;

  public constructor() {
    this.mainModules = [];
    this.additionalModules = [];
    this._initMainModules();
    this._initAdditionalModules();
  }

  private _initMainModules() {
    let actions = store.getters[_act.AUTH_GET_ACTIONSGET];

    if (actions.indexOf(10110) !== -1) {
      this.mainModules.push(new NavigationModule(eModuleTypes.DocumentAdd, 'fa-plus', '/document-add', 'primary', 0));
    }

    if (actions.indexOf(10100) !== -1) {
      let docs = new NavigationModule(eModuleTypes.DocumentsAll, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsNotProcessed + '/0', '', 0);
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsNotProcessed, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsNotProcessed + '/0', null, 0));
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsIn, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsIn + '/0', null, 0));
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsOut, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsOut + '/0', null, 0));
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsProjects, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsProjects + '/0', null, 0));
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsProcessed, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsProcessed + '/0', null, 0));
      docs.AddSubModule(new NavigationModule(eModuleTypes.DocumentsAnnulled, 'fa-file-contract', '/docs/' + eModuleTypes.DocumentsAnnulled + '/0', null, 0));
      this.mainModules.push(docs);
    }

    if (actions.indexOf(10200) !== -1) {
      let signs = new NavigationModule(eModuleTypes.Signs, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsNotProcessed + '/0', '', 0);
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsNotProcessed, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsNotProcessed + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsIn, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsIn + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsInSigned, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsInSigned + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsInRejected, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsInRejected + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsOut, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsOut + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsOutSigned, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsOutSigned + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsOutRejected, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsOutRejected + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsProcessed, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsProcessed + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsRecalling, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsRecalling + '/0', null, 0));
      signs.AddSubModule(new NavigationModule(eModuleTypes.SignsAnnulled, 'fa-pen-nib', '/docs/' + eModuleTypes.SignsAnnulled + '/0', null, 0));
      this.mainModules.push(signs);
    }

    if (actions.indexOf(10300) !== -1) {
      let agree = new NavigationModule(eModuleTypes.Agree, 'fa-check', '/docs/' + eModuleTypes.AgreeNotProcessed + '/0', '', 0);
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeNotProcessed, 'fa-check', '/docs/' + eModuleTypes.AgreeNotProcessed + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeIn, 'fa-check', '/docs/' + eModuleTypes.AgreeIn + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeInAccepted, 'fa-check', '/docs/' + eModuleTypes.AgreeInAccepted + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeInRejected, 'fa-check', '/docs/' + eModuleTypes.AgreeInRejected + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeOut, 'fa-check', '/docs/' + eModuleTypes.AgreeOut + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeOutAccepted, 'fa-check', '/docs/' + eModuleTypes.AgreeOutAccepted + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeOutRejected, 'fa-check', '/docs/' + eModuleTypes.AgreeOutRejected + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AgreeProcessed, 'fa-check', '/docs/' + eModuleTypes.AgreeProcessed + '/0', null, 0));
      this.mainModules.push(agree);
    }

    if (actions.indexOf(11700) !== -1) {
      let agree = new NavigationModule(eModuleTypes.Acquaint, 'fa-eye', '/docs/' + eModuleTypes.AcquaintNotProcessed + '/0', '', 0);
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintNotProcessed, 'fa-eye', '/docs/' + eModuleTypes.AcquaintNotProcessed + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintIn, 'fa-eye', '/docs/' + eModuleTypes.AcquaintIn + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintInProcessed, 'fa-eye', '/docs/' + eModuleTypes.AcquaintInProcessed + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintOut, 'fa-eye', '/docs/' + eModuleTypes.AcquaintOut + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintOutProcessed, 'fa-eye', '/docs/' + eModuleTypes.AcquaintOutProcessed + '/0', null, 0));
      agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintProcessed, 'fa-eye', '/docs/' + eModuleTypes.AcquaintProcessed + '/0', null, 0));
      if (globalSettingsHelper.isMOSystem) {
        agree.AddSubModule(new NavigationModule(eModuleTypes.AcquaintNotAccepted, 'fa-eye', '/docs/' + eModuleTypes.AcquaintNotAccepted + '/0', null, 0));
      }
      this.mainModules.push(agree);
    }

    if (actions.indexOf(10100) !== -1) {
      let processed = new NavigationModule(eModuleTypes.AllProcessed, 'fa-check-circle', '/docs/' + eModuleTypes.AllProcessed + '/0', '', 0);
      this.mainModules.push(processed);
    }

    if (actions.indexOf(12300) !== -1) {
      let filefold = new NavigationModule(eModuleTypes.FileFolders, 'fa-folder', '/filefolders', '', 0);
      this.mainModules.push(filefold);
    }

    if (actions.indexOf(10100) !== -1) {
      this.mainModules.push(new NavigationModule(eModuleTypes.Favorites, 'fa-star', '/docs/' + eModuleTypes.Favorites + '/0', '', 0));

      this.mainModules.push(new NavigationModule(eModuleTypes.Archive, 'fa-archive', '/docs/' + eModuleTypes.Archive + '/0', '', 0));

      this.mainModules.push(new NavigationModule(eModuleTypes.Recycle, 'fa-trash-alt', '/docs/' + eModuleTypes.Recycle + '/0', '', 0));
    }

    if (actions.indexOf(11300) !== -1) {
      this.mainModules.push(new NavigationModule(eModuleTypes.Contragents, 'fa-user', '/contragents', '', 0));
    }

    if (actions.indexOf(11200) !== -1) {
      let myfolders = new NavigationModule(eModuleTypes.MyFolders, 'fa-tag', '/folders/', '', 0);

      let folders = store.getters[_act.FOLD_GET_FOLDERS];
      for (let index = 0, len = folders.length; index < len; index++) {
        const element = folders[index];
        myfolders.AddModule(
          new NavigationModule(
            eModuleTypes.Folder,
            'fa-circle',
            '/docs/' + eModuleTypes.DocumentsAll + '/' + element.USERFOLDER_ID,
            element.USERFOLDERCOLOR,
            element.USERFOLDER_ID,
            element.USERFOLDERNAME
          )
        );
      }
      this.mainModules.push(myfolders);
    }

    if (actions.indexOf(10100) !== -1) {
      this.mainModules.push(new NavigationModule(eModuleTypes.Search, 'fa-search', '/search/' + eModuleTypes.Search + '/0', '', 0));
    }

    if (actions.some(v => [
      Permissions.EDU_DICTIONARY_GET, Permissions.EDU_PLANS_GET, Permissions.EDU_FORMS_GET, Permissions.EDU_REGISTRY_GET
    ].includes(v))) {
      let eduModule = new NavigationModule(eModuleTypes.EduModule, 'fas fa-graduation-cap', '', '', 0);
      if (actions.indexOf(Permissions.EDU_REGISTRY_GET) !== -1) {
        eduModule.AddModule(new NavigationModule(eModuleTypes.EduRegistries, 'far fa-list-alt', '/edu-registries', null, 0));
      }
      if (actions.indexOf(Permissions.EDU_DICTIONARY_GET) !== -1) {
        eduModule.AddModule(new NavigationModule(eModuleTypes.AdminDictionaries, 'fas fa-spell-check', '/admin/edu-dictionaries', null, 0));
      }
      if (actions.indexOf(Permissions.EDU_FORMS_GET) !== -1) {
        eduModule.AddModule(new NavigationModule(eModuleTypes.AdminEducationalForms, 'fab fa-wpforms', '/admin/edu-forms', null, 0));
      }
      if (actions.indexOf(Permissions.EDU_PLANS_GET) !== -1) {
        eduModule.AddModule(new NavigationModule(eModuleTypes.AdminEducationalPlans, 'fas fa-school', '/admin/edu-plans', null, 0));
      }
      if (eduModule.childModules.length > 0) {
        this.mainModules.push(eduModule);
      }
    }

    // if (actions.indexOf(12300) !== -1)
    {
      let utilities = new NavigationModule(eModuleTypes.Utilities, 'fa-wrench', '/utilities', '', 0);
      this.mainModules.push(utilities);
    }

    if (actions.indexOf(Permissions.MODULESUSE) !== -1 && globalSettingsHelper.isModulesEnabled) {
      this.mainModules.push(new NavigationModule(eModuleTypes.Modules, 'fa-store-alt', '/modules', '', 0));
    }

    if (userModulesHelper.isModuleActivated(AppModules.YouControl)) {
      this.mainModules.push(new NavigationModule(eModuleTypes.YouControl, '', '/youcontrol', null, 0));
    }

    if (actions.some(v => [
      Permissions.A_USERSGET, Permissions.A_REGTOKENGET,
      Permissions.A_SHTGET, Permissions.A_SHADGET, Permissions.ORGADMSHTGET, Permissions.ORGADMSHADGET,
      Permissions.A_ADVGET, Permissions.A_ORDERGET,
      Permissions.A_BILLINGGET, Permissions.A_PUSHSEND, Permissions.A_REPORTS, Permissions.A_DOCPARAMGET, Permissions.A_INTEGRITYGET,
      Permissions.A_PROMOACTIONGET, Permissions.A_IITFILESGET,
      Permissions.A_DICTIONARY_GET
    ].includes(v))) {
      let org = new NavigationModule(eModuleTypes.Administration, 'fas fa-tools', '', '', 0);
      if (actions.indexOf(Permissions.A_USERSGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.Clients, 'fas fa-user-shield', '/admin/clients', null, 0));
      }
      if (actions.indexOf(Permissions.A_REGTOKENGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminRegistrationKeys, 'fas fa-key', '/admin/registration-keys', null, 0));
      }
      if (actions.indexOf(Permissions.A_SHTGET) !== -1 || actions.indexOf(Permissions.A_SHADGET) !== -1 ||
          actions.indexOf(Permissions.ORGADMSHTGET) !== -1 || actions.indexOf(Permissions.ORGADMSHADGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.ShablonDocuments, 'fas fa-cubes', '/admin/shablon/documents', null, 0));
      }
      if (actions.indexOf(Permissions.A_DICTIONARY_GET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminDictionaries, 'fas fa-spell-check', '/admin/dictionaries', null, 0));
      }
      if (actions.indexOf(Permissions.A_ADVGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.Advertisement, 'fas fa-bell', '/admin/advertisement', null, 0));
      }
      if (actions.indexOf(Permissions.A_ORDERGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.ServiceOrders, 'fas fa-receipt', '/admin/serviceorders', null, 0));
      }
      if (actions.indexOf(Permissions.A_BILLINGGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.Billing, 'fas fa-file-invoice-dollar', '/admin/billing', null, 0));
      }
      if (actions.indexOf(Permissions.A_PUSHSEND) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminPushNotifications, 'fas fa-envelope', '/admin/push-notifications', null, 0));
      }
      if (actions.indexOf(Permissions.A_REPORTS) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminReports, 'fas fa-chart-pie', '/admin/reports', null, 0));
      }
      if (actions.indexOf(Permissions.A_DOCPARAMGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminDocumentExtendedParams, 'fas fa-file-powerpoint', '/admin/document-ext-params', null, 0));
      }
      if (actions.indexOf(Permissions.A_INTEGRITYGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminSystemIntegrity, 'fas fa-shield-alt', '/admin/system-integrity', null, 0));
      }
      if (actions.indexOf(Permissions.A_PROMOACTIONGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminPromoActions, 'fas fa-gift', '/admin/promo-actions', null, 0));
      }
      if (actions.indexOf(Permissions.A_IITFILESGET) !== -1) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminIitFiles, 'fas fa-file-signature', '/admin/iit-files', null, 0));
      }
      if (actions.indexOf(Permissions.A_SURVEY_GET) !== -1 && globalSettingsHelper.isSurveyEnabled) {
        org.AddModule(new NavigationModule(eModuleTypes.AdminSurveys, 'fas fa-poll', '/admin/surveys', null, 0));
      }
      this.mainModules.push(org);
    }
  }

  private _initAdditionalModules() {
    // this.additionalModules.push(new NavigationModule(eModuleTypes.Contacts, 'fa-envelope', '/contacts', '', 0));
  }

  public updateFolders() {
    let actions = store.getters[_act.AUTH_GET_ACTIONSGET];

    if (actions.indexOf(11200) !== -1) {
      let myfolders = this.mainModules.find(m => m.moduleType === eModuleTypes.MyFolders);
      if (myfolders) {
        myfolders.childModules.splice(0);

        let folders = store.getters[_act.FOLD_GET_FOLDERS];
        for (let index = 0, len = folders.length; index < len; index++) {
          const element = folders[index];
          myfolders.AddModule(
            new NavigationModule(
              eModuleTypes.Folder,
              'fa-circle',
              '/docs/' + eModuleTypes.DocumentsAll + '/' + element.USERFOLDER_ID,
              element.USERFOLDERCOLOR,
              element.USERFOLDER_ID,
              element.USERFOLDERNAME
            )
          );
        }
      }
    }
  }

  public getSubModules(moduleType) {
    var mod = this.mainModules.find(d => d.moduleType === moduleType);
    if (mod) {
      return mod.subModules;
    }
    return null;
  }
}
